export const formatAgeRestriction = (minAge?: number, maxAge?: number) => {
    if (!minAge && !maxAge) return ""; // If both are missing, show nothing
    if (minAge && maxAge) return `${minAge} - ${maxAge}`; // If both exist, format as "12 - 21"
    return `${minAge}+`; // If only one exists, add "+" (handles minAge alone)
};

